import { ReactNode } from 'react';
import './NavbarLayout.css';

const NavbarLayout = ({ children }: { children: ReactNode }) => (
  <div className='navbar-layout'>
    {children}
  </div>
);

export default NavbarLayout;